export const summary = 
`
was founded in 2008 by husband and wife team Marcus and Elena Ramirez, 
Ramirez Drafting & Design began as a passion project in the heart of San Jose, California. 
Both trained in architectural design—with Marcus focusing on structural detailing and Elena 
bringing a background in art history—the couple set out to create a drafting studio with a 
unique purpose: to preserve and celebrate the rich architectural heritage of the Bay Area. 
From a converted garage studio, they began offering custom drafting services for historic homes, 
revitalizing everything from Spanish Revival bungalows to mid-century modern landmarks.

As their reputation for excellence grew, so did their team. Ramirez Drafting & Design has expanded
to include a talented group of designers, CAD specialists, and historical consultants who share 
Marcus and Elena’s vision. This growing technical team has allowed the firm to take on more complex 
restoration projects, while still maintaining the personal, hands-on approach that set them apart 
from the start. Today, the firm continues to blend traditional drafting techniques with modern technology, 
serving as a trusted resource for homeowners, preservation boards, and contractors across the Bay Area.
`

export const missionStatement = 
`
is dedicated to preserving architectural character while embracing modern functionality, 
this San Jose-based historical architectural studio offers a comprehensive range of residential 
design and construction services. From kitchen and bathroom remodels to full home renovations, 
ADU development, and structural upgrades, the studio is committed to honoring the legacy of historic 
homes while enhancing livability. Their expertise also extends to public works and commercial projects,
 providing thoughtful design solutions that respect the past and serve the needs of today’s communities. 
 With a focus on permitting, code compliance, and development planning, the studio brings a collaborative
  and detail-oriented approach to every project—supporting homeowners, municipalities, and businesses alike.
`

export const teamstatement = 
`
is built on the belief that local professionals bring invaluable regional 
insight, creativity, and craftsmanship to each project. The studio places a strong emphasis on collaborative design and takes great pride in sourcing and 
nurturing California-based talent. Every project is a reflection of this shared effort, and the team’s collective spirit continues to 
shape meaningful, lasting work across the South Bay.
`